module.exports = __webpack_public_path__ + "afdf5c22fa387afc22e330ab5ff010dc.MP3";